export enum FcmPermissions {
    GRANTED = 'granted',
    DENIED = 'denied',
    DEFAULT = 'default',
    DEFAULT_DENIED = 'default_denied' // only for stats
}
